import React, {FC, useRef} from 'react'
import {KTSVG} from '../../helpers'
import {useFormik} from 'formik'
import {useStatusMessage} from '../../../app/features'
import {Post} from '../../../setup'
import {ModalNoteInterface} from './types'
import {useNotifications, useForms} from '../../../app/@contexts'
import {Modal} from './Modal'

interface InterfaceInitialValues {
    notes: string
}

const CREATE_NOTE = process.env.REACT_APP_WEB_FORMS_CREATE_NOTE

const UpdateNoteWebForm: FC<ModalNoteInterface> = ({notes, id, textIcon, size}) => {

    const modalTarget = `edit_note_${id}`

    return (
        <>
            <Modal
                button={{
                    bg: 'warning',
                    tooltip: 'Notes',
                    text: textIcon ? 'Notes' : undefined,
                    icon: {show: true, svg: 'communication/com003'},
                }}
                modal={{
                    id: `${modalTarget}`,
                    size,
                    content: <Content id={id} notes={notes} />,
                }}
            />
        </>
    )
}

export {UpdateNoteWebForm}

const Content: FC<{id: string, notes: string}> = ({id, notes}) => {

    const {triggerReload} = useForms()
    const {formState, setLoading} = useStatusMessage()
    const modalClose = useRef<HTMLButtonElement | null>(null)
    const endpoint = `${CREATE_NOTE}/${id}`
    const {setToast} = useNotifications()

    const onSubmit = async (values: InterfaceInitialValues, {setSubmitting}: {
        setSubmitting: (isSubmitting: boolean) => void
    }) => {

        setLoading(true)
        try {
            const {status, message} = await Post<any>(endpoint, values)
            setToast({type: 'success', text: {title: 'Notes', message}})
            if (modalClose.current && status === 200) {
                triggerReload()
                setTimeout(() => {
                    modalClose.current?.click()
                }, 2600)
            }

        } catch (err) {
            console.error('Error submitting the form:', err)
        } finally {
            setLoading(false)
            setSubmitting(false)
        }
    }

    const formik = useFormik({
        initialValues: {notes: notes || ''},
        enableReinitialize: true,
        onSubmit,
    })

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="modal-header">
                <h2>Notes</h2>
                <div className="btn btn-sm btn-icon btn-active-color-primary"
                     data-bs-dismiss="modal">
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                </div>
            </div>
            <div className="modal-body p-3 p-sm-5 p-md-7">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                            <textarea className="form-control form-control-solid"
                                      id={`note_${id}`}
                                      rows={5} cols={33}
                                      {...formik.getFieldProps('notes')}
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="submit" className="btn btn-sm btn-primary me-2 px-6"
                        disabled={formState.loading}>
                    {formState.loading ? (
                        <span className="indicator-progress d-block">
                            S'il vous plaît, attendez...
                            <span className="spinner-border spinner-border-sm align-middle ms-2" />
                        </span>
                    ) : (
                        'Sauvegarder'
                    )}
                </button>
                <button type="button"
                        className="btn btn-sm btn-light me-2 px-6"
                        data-bs-dismiss="modal"
                        ref={modalClose}
                        onClick={() => {
                            formik.resetForm()
                            setLoading(false)
                        }}
                >
                    Fermer
                </button>
            </div>
        </form>
    )
}